var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"0px","padding":"0","width":"100%","height":"100%","overflow":"hidden","background-color":"transparent"},attrs:{"data-aa":_vm.unitId,"src":("//acceptable.a-ads.com/" + _vm.unitId)}})}
var staticRenderFns = []

export { render, staticRenderFns }